/** Defines the React context and hook for managing task data and global task-related state. */
// @ts-check
import { createContext, useContext } from 'react';

/** * De context zelf, getypeerd met onze interface.
 * @type {import('react').Context<TasksContextValue | null>}
 */
export const TasksContext = createContext(null);

/**
 * Consumer hook voor TasksContext.
 * @returns {TasksContextValue}
 */
export const useTasksContext = () => {
  const context = useContext(TasksContext);
  if (context === null) {
    throw new Error('useTasksContext must be used within a TasksProvider');
  }
  return context;
};
